export default __webpack_public_path__ + "static/media/banner-mobile-light.d372fe6f.jpg";